import { defineMessages } from 'react-intl'

const scope = 'modules.expense-approvals.components.WatchlistApproverSelect'

export default defineMessages({
  placeholder: {
    id: `${scope}.placeholder`,
    defaultMessage: 'Viewing as...',
  },
  allLabel: {
    id: `${scope}.allLabel`,
    defaultMessage: 'All',
  },
})
